const Raven = require('raven-js');
const clientConfig = Raven.config(process.env.SENTRY_PUBLIC_DSN, {
    logger: 'client',
    release: process.env.RELEASE,
    environment: process.env.NODE_ENV
});
let client = null;

if (process.env.SENTRY_ENABLED && process.env.SENTRY_ENABLED !== "false") {
    client = clientConfig.install();
}

export function logException(e, context = {}) {
    if (client && process.env.SENTRY_ENABLED && process.env.SENTRY_ENABLED !== "false") {
        client.captureException(e, {
            extra: Object.assign({}, context, {"_env": process.env})
        });
    }
    /* eslint no-console:0*/
    console && console.error && console.error(e);
}

export function setUserContext(user) {
    if (client) {
        client.setUserContext({
            email: user.email,
            id: user.id
        });
    }
}

export default {
    logException,
    setUserContext
};



// WEBPACK FOOTER //
// ./app/utils/sentry.js